import { createSelector } from 'reselect';
import orderBy from 'lodash/orderBy';
import filter from 'lodash/filter';

const defaultInitialState = {
	selectControlsParams: [
		{
			id: 1,
			orderFirst: true,
			value: 'date',
			name: 'first',
			placeholder: 'Первый параметр',
			searchable: false,
			clearable: false,
			options: null
		},
		{
			id: 2,
			orderFirst: false,
			name: 'second',
			value: null,
			placeholder: 'Второй параметр',
			searchable: false,
			clearable: true,
			options: null
		}
	]
};

const createGroups = ({ namespace, stateNodeName = 'groups' }) => {
	// action types
	const CHOOSE_ITEM = `${namespace}/${stateNodeName}-choose-item`;
	const SWITCH_ORDER = `${namespace}/${stateNodeName}-switch-order`;
	const SET_VALUE = `${namespace}/${stateNodeName}-set-value`;

	// init state
	const initialState = {
		...defaultInitialState
	};

	// actions
	const actions = {
		[`${stateNodeName}ChooseItem`]: (selectId, selected) => dispatch => {
			dispatch({
				type: CHOOSE_ITEM,
				payload: {
					selectId,
					selected
				}
			});
		},

		[`${stateNodeName}SwitchOrder`]: () => ({
			type: SWITCH_ORDER
		}),

		[`${stateNodeName}SetValue`]: groupsValue => ({
			type: SET_VALUE,
			payload: groupsValue
		})
	};

	// reducers
	const reducers = {
		[CHOOSE_ITEM]: (state, action) => {
			const { selectId, selected } = action.payload;

			const selectControlsParams = state.groups.selectControlsParams.map(select => {
				const cloneSelect = { ...select };
				if (cloneSelect.id === selectId) {
					cloneSelect.value = selected ? selected.value : null;
				}
				return cloneSelect;
			});
			return { ...state, groups: { ...state.groups, selectControlsParams } };
		},

		[SWITCH_ORDER]: state => {
			const selectControls = state.groups.selectControlsParams.map(select => {
				const cloneSelect = { ...select };
				cloneSelect.orderFirst = !cloneSelect.orderFirst;
				return cloneSelect;
			});

			const selectControlsParams = orderBy(selectControls, 'orderFirst', 'desc');

			return { ...state, groups: { ...state.groups, selectControlsParams } };
		},

		[SET_VALUE]: (state, action) => {
			const selectControlsParams = state.groups.selectControlsParams.map((select, index) => {
				const cloneSelect = { ...select };
				if (action.payload[index]) {
					cloneSelect.value = action.payload[index];
				}
				return cloneSelect;
			});
			return {
				...state,
				groups: {
					...state.groups,
					selectControlsParams
				}
			};
		}
	};

	// selectors
	const selectors = {
		getData: (groupsControlSelector, appState) =>
			createSelector(groupsControlSelector, appState, (groupsControl, appState) => {
				const { selectControlsParams } = appState.statistics.groups;
				const params = appState.statistics.table.groupColumns;
				const [firstSelect, secondSelect] = [...selectControlsParams];

				firstSelect.options = getOptions(secondSelect, params);
				secondSelect.options = getOptions(firstSelect, params);

				return {
					selectControlsParams: [firstSelect, secondSelect]
				};
			})
	};

	return {
		initialState,
		actions,
		reducers,
		selectors
	};
};

export default createGroups;

function getOptions(select, params) {
	const options = filter(params, param => param.id !== select.value);
	return options.map(option => ({
		value: option.id,
		label: option.title
	}));
}



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/statistics/components/groups/index.js